import { Animated, View, Pressable, Text } from 'react-native';
import React, { useCallback, useEffect, useState } from 'react';
import useForm from '@hooks/useForm';
import {
  CodeField,
  Cursor,
  useBlurOnFulfill,
  useClearByFocusCell,
} from 'react-native-confirmation-code-field';
import { Entypo, Ionicons } from "@expo/vector-icons";

import otpStyles, {
  ACTIVE_CELL_BG_COLOR,
  CELL_BORDER_RADIUS,
  CELL_SIZE,
  DEFAULT_CELL_BG_COLOR,
  NOT_EMPTY_CELL_BG_COLOR,
} from './Styles';
import { useDispatch, useSelector } from 'react-redux';
import LottieView from '@utils/lottieAnimation';
import { DefaultRootState, store } from "@reduxLocal/persistState";
import { TOGGLE_OTP } from '@reduxLocal/actions/types';
import styles from '@stylesheet';
import { loginUser } from '@api';
import Button from '@components/UI/Button/Button';
import useGlobalUser from '@hooks/getGlobalUser';
import apis from '@api/api';

const { Value, Text: AnimatedText } = Animated;

const CELL_COUNT = 6;

const animationsColor = [...new Array(CELL_COUNT)].map(() => new Value(0));
const animationsScale = [...new Array(CELL_COUNT)].map(() => new Value(1));
const animateCell = ({ hasValue, index, isFocused }) => {
  Animated.parallel([
    Animated.timing(animationsColor[index], {
      useNativeDriver: false,
      toValue: isFocused ? 1 : 0,
      duration: 250,
    }),
    Animated.spring(animationsScale[index], {
      useNativeDriver: false,
      toValue: hasValue ? 0 : 1,
      duration: hasValue ? 300 : 250,
    }),
  ]).start();
};

const OTPValidate = ({ setModal }) => {
  const dispatch = useDispatch();
  const [isPinReady, setIsPinReady] = useState(false);
  const [value, setValue] = useState('');
  const ref = useBlurOnFulfill({ value, cellCount: CELL_COUNT });
  const [loading, setLoading] = useState(false);
  const userId = useGlobalUser();
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue,
  });


  useEffect(() => {
    if (value.length === CELL_COUNT) {
      setIsPinReady(true);
      handleValidate()
    }
  }, [value])

  const _closeModal = useCallback(() => {
    setModal()
  }, [])

  const handleValidate = async () => {
    await apis.validate2FA(userId, value).then(() => {
      _closeModal();
    })
  }

  const renderCell = ({ index, symbol, isFocused }) => {
    const hasValue = Boolean(symbol);
    const animatedCellStyle = {
      backgroundColor: hasValue
        ? animationsScale[index].interpolate({
          inputRange: [0, 1],
          outputRange: [NOT_EMPTY_CELL_BG_COLOR, ACTIVE_CELL_BG_COLOR],
        })
        : animationsColor[index].interpolate({
          inputRange: [0, 1],
          outputRange: [DEFAULT_CELL_BG_COLOR, ACTIVE_CELL_BG_COLOR],
        }),
      borderRadius: animationsScale[index].interpolate({
        inputRange: [0, 1],
        outputRange: [CELL_SIZE, CELL_BORDER_RADIUS],
      }),
      transform: [
        {
          scale: animationsScale[index].interpolate({
            inputRange: [0, 1],
            outputRange: [0.2, 1],
          }),
        },
      ],
    };

    // Run animation on next event loop tik
    // Because we need first return new style prop and then animate this value
    setTimeout(() => {
      animateCell({ hasValue, index, isFocused });
    }, 0);

    return (
      <AnimatedText
        key={index}
        style={[otpStyles.cell, animatedCellStyle]}
        onLayout={getCellOnLayoutHandler(index)}>
        {symbol || (isFocused ? <Cursor /> : null)}
      </AnimatedText>
    );
  };

  return (
    <View style={[otpStyles.root, { alignContent: 'center' }]}>
      {/* <Image style={otpStyles.icon} source={source} /> */}
      <View style={{ flex: 1, maxWidth: '100%', alignContent: 'center', justifyContent: 'center' }}>
        {
          loading ?
            <LottieView style={{ width: '70%', alignSelf: 'center', justifyContent: 'center', flex: 1 }} source={require('@assets/animations/custom_Loader.json')} autoPlay loop />
            :
            <>
              <Text style={{ flex: 1, paddingHorizontal:100 }}>Scan the code above with your smartphone and select your preferred authentication app</Text>
              <CodeField
                ref={ref}
                value={value}
                onChangeText={(value) => { setValue(value) }}
                cellCount={CELL_COUNT}
                rootStyle={otpStyles.codeFiledRoot}
                textContentType="oneTimeCode"
                renderCell={renderCell}
                selectTextOnFocus={true}
              />
              <View style={{ flexDirection: 'row', flex: 1, maxWidth: '100%', justifyContent: 'center', alignContent: 'center', alignItems: 'center', alignSelf: 'center', paddingHorizontal: 80 }}>
                <Button
                  disabled={!isPinReady || loading ? true : false}
                  onPress={() => {
                    formLoginContext.handleSubmit()
                  }
                  }
                  buttonText='Validate'
                  icon={<Ionicons name={"arrow-forward-outline"} size={20} color={'white'} ></Ionicons>}
                />
              </View>
            </>
        }
      </View>
    </View>
  );
};

export default OTPValidate;